/*
Copyright (c) 2019-present NAVER Corp.
name: @egjs/svelte-infinitegrid
license: MIT
author: NAVER Corp.
repository: https://github.com/naver/egjs-infinitegrid
version: 3.0.4
*/
import { SvelteComponent, init, safe_not_equal, assign, element, set_attributes, insert, group_outros, transition_out, check_outros, transition_in, get_spread_update, detach, exclude_internal_props, binding_callbacks, create_slot, bind, space, create_component, mount_component, get_slot_context, get_slot_changes, add_flush_callback, destroy_component, attr, append } from 'svelte/internal';
import { onMount, createEventDispatcher, beforeUpdate, afterUpdate, onDestroy } from 'svelte';
import VanillaInfiniteGrid, { categorize, ItemManager, INFINITEGRID_EVENTS, GridLayout as GridLayout$1, CONTAINER_CLASSNAME, INFINITEGRID_METHODS, JustifiedLayout as JustifiedLayout$1, FrameLayout as FrameLayout$1, SquareLayout as SquareLayout$1, PackingLayout as PackingLayout$1 } from '@egjs/infinitegrid';

/* src/LoadingChecker.svelte generated by Svelte v3.16.7 */

function instance($$self, $$props, $$invalidate) {
  let {
    hasLoading = true
  } = $$props;
  onMount(() => {
    $$invalidate(0, hasLoading = false);
  });

  $$self.$set = $$props => {
    if ("hasLoading" in $$props) $$invalidate(0, hasLoading = $$props.hasLoading);
  };

  return [hasLoading];
}

class LoadingChecker extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance, null, safe_not_equal, {
      hasLoading: 0
    });
  }

}

const PROP_NAMES = ["groupBy", "itemBy", "items", "useFirstRender", "loading", "status", "layoutType", "options", "layoutOptions", "_forceCount", "viewer", "container"];

/* src/InfiniteGrid.svelte generated by Svelte v3.16.7 */

const get_loading_slot_changes_1 = dirty => ({
  visibleItems: dirty[0] &
  /*visibleItems*/
  8
});

const get_loading_slot_context_1 = ctx => ({
  visibleItems:
  /*visibleItems*/
  ctx[3]
});

const get_default_slot_changes_1 = dirty => ({
  visibleItems: dirty[0] &
  /*visibleItems*/
  8
});

const get_default_slot_context_1 = ctx => ({
  visibleItems:
  /*visibleItems*/
  ctx[3]
});

const get_loading_slot_changes = dirty => ({
  visibleItems: dirty[0] &
  /*visibleItems*/
  8
});

const get_loading_slot_context = ctx => ({
  visibleItems:
  /*visibleItems*/
  ctx[3]
});

const get_default_slot_changes = dirty => ({
  visibleItems: dirty[0] &
  /*visibleItems*/
  8
});

const get_default_slot_context = ctx => ({
  visibleItems:
  /*visibleItems*/
  ctx[3]
}); // (142:2) {:else}


function create_else_block(ctx) {
  let t;
  let updating_hasLoading;
  let current;
  const default_slot_template =
  /*$$slots*/
  ctx[28].default;
  const default_slot = create_slot(default_slot_template, ctx,
  /*$$scope*/
  ctx[27], get_default_slot_context_1);
  const loading_slot_template =
  /*$$slots*/
  ctx[28].loading;
  const loading_slot = create_slot(loading_slot_template, ctx,
  /*$$scope*/
  ctx[27], get_loading_slot_context_1);

  function loadingchecker_hasLoading_binding_1(value) {
    /*loadingchecker_hasLoading_binding_1*/
    ctx[31].call(null, value);
  }

  let loadingchecker_props = {};

  if (
  /*hasLoadingElement*/
  ctx[4] !== void 0) {
    loadingchecker_props.hasLoading =
    /*hasLoadingElement*/
    ctx[4];
  }

  const loadingchecker = new LoadingChecker({
    props: loadingchecker_props
  });
  binding_callbacks.push(() => bind(loadingchecker, "hasLoading", loadingchecker_hasLoading_binding_1));
  return {
    c() {
      if (default_slot) default_slot.c();
      t = space();

      if (!loading_slot) {
        create_component(loadingchecker.$$.fragment);
      }

      if (loading_slot) loading_slot.c();
    },

    m(target, anchor) {
      if (default_slot) {
        default_slot.m(target, anchor);
      }

      insert(target, t, anchor);

      if (!loading_slot) {
        mount_component(loadingchecker, target, anchor);
      }

      if (loading_slot) {
        loading_slot.m(target, anchor);
      }

      current = true;
    },

    p(ctx, dirty) {
      if (default_slot && default_slot.p && dirty[0] &
      /*$$scope, visibleItems*/
      134217736) {
        default_slot.p(get_slot_context(default_slot_template, ctx,
        /*$$scope*/
        ctx[27], get_default_slot_context_1), get_slot_changes(default_slot_template,
        /*$$scope*/
        ctx[27], dirty, get_default_slot_changes_1));
      }

      if (!loading_slot) {
        const loadingchecker_changes = {};

        if (!updating_hasLoading && dirty[0] &
        /*hasLoadingElement*/
        16) {
          updating_hasLoading = true;
          loadingchecker_changes.hasLoading =
          /*hasLoadingElement*/
          ctx[4];
          add_flush_callback(() => updating_hasLoading = false);
        }

        loadingchecker.$set(loadingchecker_changes);
      }

      if (loading_slot && loading_slot.p && dirty[0] &
      /*$$scope, visibleItems*/
      134217736) {
        loading_slot.p(get_slot_context(loading_slot_template, ctx,
        /*$$scope*/
        ctx[27], get_loading_slot_context_1), get_slot_changes(loading_slot_template,
        /*$$scope*/
        ctx[27], dirty, get_loading_slot_changes_1));
      }
    },

    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      transition_in(loadingchecker.$$.fragment, local);
      transition_in(loading_slot, local);
      current = true;
    },

    o(local) {
      transition_out(default_slot, local);
      transition_out(loadingchecker.$$.fragment, local);
      transition_out(loading_slot, local);
      current = false;
    },

    d(detaching) {
      if (default_slot) default_slot.d(detaching);
      if (detaching) detach(t);

      if (!loading_slot) {
        destroy_component(loadingchecker, detaching);
      }

      if (loading_slot) loading_slot.d(detaching);
    }

  };
} // (135:2) {#if options.isOverflowScroll}


function create_if_block(ctx) {
  let div;
  let t;
  let updating_hasLoading;
  let current;
  const default_slot_template =
  /*$$slots*/
  ctx[28].default;
  const default_slot = create_slot(default_slot_template, ctx,
  /*$$scope*/
  ctx[27], get_default_slot_context);
  const loading_slot_template =
  /*$$slots*/
  ctx[28].loading;
  const loading_slot = create_slot(loading_slot_template, ctx,
  /*$$scope*/
  ctx[27], get_loading_slot_context);

  function loadingchecker_hasLoading_binding(value) {
    /*loadingchecker_hasLoading_binding*/
    ctx[29].call(null, value);
  }

  let loadingchecker_props = {};

  if (
  /*hasLoadingElement*/
  ctx[4] !== void 0) {
    loadingchecker_props.hasLoading =
    /*hasLoadingElement*/
    ctx[4];
  }

  const loadingchecker = new LoadingChecker({
    props: loadingchecker_props
  });
  binding_callbacks.push(() => bind(loadingchecker, "hasLoading", loadingchecker_hasLoading_binding));
  return {
    c() {
      div = element("div");
      if (default_slot) default_slot.c();
      t = space();

      if (!loading_slot) {
        create_component(loadingchecker.$$.fragment);
      }

      if (loading_slot) loading_slot.c();
      attr(div, "class", CONTAINER_CLASSNAME);
    },

    m(target, anchor) {
      insert(target, div, anchor);

      if (default_slot) {
        default_slot.m(div, null);
      }

      append(div, t);

      if (!loading_slot) {
        mount_component(loadingchecker, div, null);
      }

      if (loading_slot) {
        loading_slot.m(div, null);
      }
      /*div_binding*/


      ctx[30](div);
      current = true;
    },

    p(ctx, dirty) {
      if (default_slot && default_slot.p && dirty[0] &
      /*$$scope, visibleItems*/
      134217736) {
        default_slot.p(get_slot_context(default_slot_template, ctx,
        /*$$scope*/
        ctx[27], get_default_slot_context), get_slot_changes(default_slot_template,
        /*$$scope*/
        ctx[27], dirty, get_default_slot_changes));
      }

      if (!loading_slot) {
        const loadingchecker_changes = {};

        if (!updating_hasLoading && dirty[0] &
        /*hasLoadingElement*/
        16) {
          updating_hasLoading = true;
          loadingchecker_changes.hasLoading =
          /*hasLoadingElement*/
          ctx[4];
          add_flush_callback(() => updating_hasLoading = false);
        }

        loadingchecker.$set(loadingchecker_changes);
      }

      if (loading_slot && loading_slot.p && dirty[0] &
      /*$$scope, visibleItems*/
      134217736) {
        loading_slot.p(get_slot_context(loading_slot_template, ctx,
        /*$$scope*/
        ctx[27], get_loading_slot_context), get_slot_changes(loading_slot_template,
        /*$$scope*/
        ctx[27], dirty, get_loading_slot_changes));
      }
    },

    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      transition_in(loadingchecker.$$.fragment, local);
      transition_in(loading_slot, local);
      current = true;
    },

    o(local) {
      transition_out(default_slot, local);
      transition_out(loadingchecker.$$.fragment, local);
      transition_out(loading_slot, local);
      current = false;
    },

    d(detaching) {
      if (detaching) detach(div);
      if (default_slot) default_slot.d(detaching);

      if (!loading_slot) {
        destroy_component(loadingchecker);
      }

      if (loading_slot) loading_slot.d(detaching);
      /*div_binding*/

      ctx[30](null);
    }

  };
}

function create_fragment(ctx) {
  let div;
  let current_block_type_index;
  let if_block;
  let current;
  const if_block_creators = [create_if_block, create_else_block];
  const if_blocks = [];

  function select_block_type(ctx, dirty) {
    if (
    /*options*/
    ctx[2].isOverflowScroll) return 0;
    return 1;
  }

  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  let div_levels = [
  /*attributes*/
  ctx[5]];
  let div_data = {};

  for (let i = 0; i < div_levels.length; i += 1) {
    div_data = assign(div_data, div_levels[i]);
  }

  return {
    c() {
      div = element("div");
      if_block.c();
      set_attributes(div, div_data);
    },

    m(target, anchor) {
      insert(target, div, anchor);
      if_blocks[current_block_type_index].m(div, null);
      /*div_binding_1*/

      ctx[32](div);
      current = true;
    },

    p(ctx, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx);

      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];

        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
          if_block.c();
        }

        transition_in(if_block, 1);
        if_block.m(div, null);
      }

      set_attributes(div, get_spread_update(div_levels, [dirty[0] &
      /*attributes*/
      32 &&
      /*attributes*/
      ctx[5]]));
    },

    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },

    o(local) {
      transition_out(if_block);
      current = false;
    },

    d(detaching) {
      if (detaching) detach(div);
      if_blocks[current_block_type_index].d();
      /*div_binding_1*/

      ctx[32](null);
    }

  };
}

function instance$1($$self, $$props, $$invalidate) {
  let {
    groupBy = (item, index) => item.groupKey
  } = $$props;
  let {
    itemBy = (item, index) => item.key
  } = $$props;
  let {
    items = []
  } = $$props;
  let {
    useFirstRender = false
  } = $$props;
  let {
    status = null
  } = $$props;
  let {
    layoutType = GridLayout$1
  } = $$props;
  let {
    options = {}
  } = $$props;
  let {
    layoutOptions = {}
  } = $$props;
  let {
    viewer = null
  } = $$props;
  let {
    container = null
  } = $$props;
  let {
    _forceCount = 0
  } = $$props;
  const dispatch = createEventDispatcher();

  let nextFunction = () => {};

  let layoutState;
  let visibleItems = [];
  let ig;
  let hasLoadingElement = true;
  let attributes = {};
  let isFirstMount = true;

  function toItems(items) {
    return items.map((item, i) => ({
      groupKey: groupBy(item, i),
      itemKey: itemBy(item, i),
      data: item
    }));
  }

  function beforeSync(items) {
    return ig.beforeSync(toItems(items));
  }

  function getLoadingElement() {
    if (hasLoadingElement) {
      const el = container || viewer;
      return el.lastElementChild;
    }
  }

  function getElements() {
    const el = container || viewer;
    const elements = [].slice.call(el.children);

    if (hasLoadingElement) {
      return elements.slice(0, -1);
    }

    return elements;
  }

  function updateAttributes() {
    $$invalidate(5, attributes = { ...$$props
    });
    PROP_NAMES.forEach(name => {
      delete attributes[name];
    });
  }

  const groups = categorize(items);

  if (status) {
    const {
      startCursor,
      endCursor
    } = status._infinite;
    visibleItems = ItemManager.pluck(groups.slice(startCursor, endCursor + 1), "items").map(item => item.data);
  } else if (useFirstRender && groups[0]) {
    visibleItems = groups[0].items.map(item => item.data);
  }

  beforeUpdate(() => {
    updateAttributes();

    if (!ig) {
      return;
    }

    const result = beforeSync(items);
    layoutState = result === "relayout" ? result : layoutState || result;
    $$invalidate(3, visibleItems = ig.getRenderingItems().map(item => item.data));
    const loadingElement = getLoadingElement();

    if (loadingElement) {
      ig.setLoadingBar({
        append: loadingElement,
        prepend: loadingElement
      });
    } else {
      ig.setLoadingBar();
    }
  });
  onMount(() => {
    ig = new VanillaInfiniteGrid(viewer, { ...options,
      renderExternal: true
    }).on("render", ({
      next
    }) => {
      setTimeout(() => {
        nextFunction = next;
        $$invalidate(6, ++_forceCount);
      });
    });
    INFINITEGRID_EVENTS.forEach(name => {
      ig.on(name, e => {
        dispatch(name, e);
      });
    });
    ig.setLayout(layoutType, layoutOptions);
    const loadingElement = getLoadingElement();

    if (loadingElement) {
      ig.setLoadingBar({
        append: loadingElement,
        prepend: loadingElement
      });
    }

    if (status) {
      ig.setStatus(status, true, getElements());
    } else {
      beforeSync(items);
      ig.layout(true);
    }
  });
  afterUpdate(() => {
    if (isFirstMount) {
      isFirstMount = false;
      return;
    }

    const currentNextFunction = nextFunction;

    nextFunction = () => {};

    ig.sync(getElements());

    if (layoutState) {
      layoutState = "";
      ig.layout(layoutState === "relayout");
    }

    currentNextFunction();
  });
  onDestroy(() => {
    ig.destroy();
  });

  function getInstance() {
    return ig;
  }

  let {
    $$slots = {},
    $$scope
  } = $$props;

  function loadingchecker_hasLoading_binding(value) {
    hasLoadingElement = value;
    $$invalidate(4, hasLoadingElement);
  }

  function div_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      $$invalidate(1, container = $$value);
    });
  }

  function loadingchecker_hasLoading_binding_1(value) {
    hasLoadingElement = value;
    $$invalidate(4, hasLoadingElement);
  }

  function div_binding_1($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      $$invalidate(0, viewer = $$value);
    });
  }

  $$self.$set = $$new_props => {
    $$invalidate(26, $$props = assign(assign({}, $$props), exclude_internal_props($$new_props)));
    if ("groupBy" in $$new_props) $$invalidate(7, groupBy = $$new_props.groupBy);
    if ("itemBy" in $$new_props) $$invalidate(8, itemBy = $$new_props.itemBy);
    if ("items" in $$new_props) $$invalidate(9, items = $$new_props.items);
    if ("useFirstRender" in $$new_props) $$invalidate(10, useFirstRender = $$new_props.useFirstRender);
    if ("status" in $$new_props) $$invalidate(11, status = $$new_props.status);
    if ("layoutType" in $$new_props) $$invalidate(12, layoutType = $$new_props.layoutType);
    if ("options" in $$new_props) $$invalidate(2, options = $$new_props.options);
    if ("layoutOptions" in $$new_props) $$invalidate(13, layoutOptions = $$new_props.layoutOptions);
    if ("viewer" in $$new_props) $$invalidate(0, viewer = $$new_props.viewer);
    if ("container" in $$new_props) $$invalidate(1, container = $$new_props.container);
    if ("_forceCount" in $$new_props) $$invalidate(6, _forceCount = $$new_props._forceCount);
    if ("$$scope" in $$new_props) $$invalidate(27, $$scope = $$new_props.$$scope);
  };

  $$props = exclude_internal_props($$props);
  return [viewer, container, options, visibleItems, hasLoadingElement, attributes, _forceCount, groupBy, itemBy, items, useFirstRender, status, layoutType, layoutOptions, getInstance, nextFunction, layoutState, ig, isFirstMount, dispatch, toItems, beforeSync, getLoadingElement, getElements, updateAttributes, groups, $$props, $$scope, $$slots, loadingchecker_hasLoading_binding, div_binding, loadingchecker_hasLoading_binding_1, div_binding_1];
}

class InfiniteGrid extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$1, create_fragment, safe_not_equal, {
      groupBy: 7,
      itemBy: 8,
      items: 9,
      useFirstRender: 10,
      status: 11,
      layoutType: 12,
      options: 2,
      layoutOptions: 13,
      viewer: 0,
      container: 1,
      _forceCount: 6,
      getInstance: 14
    }, [-1, -1]);
  }

  get getInstance() {
    return this.$$.ctx[14];
  }

}

var InfiniteGrid$1 = /*#__PURE__*/
(() => {
  const prototype = InfiniteGrid.prototype;

  for (const name in INFINITEGRID_METHODS) {
    prototype[name] = function (...args) {
      const self = this.getInstance();
      const result = self[name](...args);

      if (result === self) {
        return this;
      } else {
        return result;
      }
    };
  }

  return InfiniteGrid;
})();

class GridLayout extends InfiniteGrid {
  constructor(options) {
    options.props.layoutType = GridLayout$1;
    super(options);
  }

}

class JustifiedLayout extends InfiniteGrid {
  constructor(options) {
    options.props.layoutType = JustifiedLayout$1;
    super(options);
  }

}

class FrameLayout extends InfiniteGrid {
  constructor(options) {
    options.props.layoutType = FrameLayout$1;
    super(options);
  }

}

class SquareLayout extends InfiniteGrid {
  constructor(options) {
    options.props.layoutType = SquareLayout$1;
    super(options);
  }

}

class PackingLayout extends InfiniteGrid {
  constructor(options) {
    options.props.layoutType = PackingLayout$1;
    super(options);
  }

}

export default InfiniteGrid$1;
export { FrameLayout, GridLayout, JustifiedLayout, PackingLayout, SquareLayout };
//# sourceMappingURL=infinitegrid.esm.js.map
